import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceLine, ResponsiveContainer,
} from 'recharts';
import PremiumGate from '../../PremiumGate';
import Tier from '../../../constants/tiers';
import { DATA_COLORS } from '../../../constants/dataColors';
import { formatCurrencyByLocaleShort } from '../../../utils/currencyUtils';

function FireProjectionChart({ projection, currencyInfo, userInfo }) {
  const isPremium = userInfo && userInfo.tier === Tier.PREMIUM;

  if (!isPremium) {
    return (
      <PremiumGate message="Upgrade to Premium to see your full multi-decade FIRE projection chart." />
    );
  }

  const { yearlyData, fireNumber } = projection;
  const { locale, aggregationCurrency } = currencyInfo;

  const formatY = value => formatCurrencyByLocaleShort(locale, aggregationCurrency, value);

  return (
    <ResponsiveContainer width="100%" height={350}>
      <LineChart data={yearlyData} margin={{ top: 10, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="year" />
        <YAxis tickFormatter={formatY} width={90} />
        <Tooltip
          formatter={(value, name) => [formatCurrencyByLocaleShort(locale, aggregationCurrency, value), name]}
          labelFormatter={label => label}
        />
        <Legend />
        <ReferenceLine y={fireNumber} stroke={DATA_COLORS[1]} strokeDasharray="6 3" label={{ value: 'FIRE', position: 'insideTopRight', fill: DATA_COLORS[1] }} />
        <Line
          type="monotone"
          dataKey="netWorth"
          name="Net Worth"
          stroke={DATA_COLORS[0]}
          dot={false}
          strokeWidth={2}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}

export default FireProjectionChart;
